import { cn } from "@homeinstead/ui";

// if the stack is under 360px width, we need to shrink down the background to 320px
const STACK_BG_CLASS = "w-72 [@media(min-width:360px)]:w-[344px]";

/**
 * @deprecated Use an FeaturedOnStack from `@homeinstead/ui/components/FeaturedNewsLogos` instead
 */
// Mobile stacked layout component
export const FeaturedOnStack = () => {
  return (
    // this doesn't show if we're > lg width
    <div className="flex flex-col items-center lg:hidden">
      <div className="relative">
        <div
          className={cn(
            // the bg image when we're this size
            "relative mx-10 mb-8 h-12 bg-[url('/i/featured/background-sm.svg')] bg-center bg-contain bg-no-repeat",
            STACK_BG_CLASS,
          )}
        >
          <p
            className={cn(
              "flex h-full items-center justify-center px-6 text-center font-medium text-new-beginnings-base",
              STACK_BG_CLASS,
            )}
          >
            Featured on:
          </p>
        </div>
      </div>
    </div>
  );
};

/**
 * @deprecated Use an FeaturedOnRow from `@homeinstead/ui/components/FeaturedNewsLogos` instead
 */
// Desktop row layout component
export const FeaturedOnRow = () => {
  return (
    // we only show this one on lg size and up
    <div className="hidden shrink-0 lg:block">
      <div className="relative h-12 w-48 bg-[url('/i/featured/background.svg')] bg-center bg-contain bg-no-repeat">
        <p className="flex h-full items-center px-6 font-medium text-new-beginnings-base">
          As featured on:
        </p>
      </div>
    </div>
  );
};
